import { render } from "./UpgradeModal.vue?vue&type=template&id=5567ad9b&scoped=true"
import script from "./UpgradeModal.vue?vue&type=script&lang=js"
export * from "./UpgradeModal.vue?vue&type=script&lang=js"

import "./UpgradeModal.vue?vue&type=style&index=0&id=5567ad9b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5567ad9b"]])

export default __exports__